import React, { JSX } from 'react';
import { Button } from 'reactstrap';
import { Select } from '../../Form/Select/Select';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import { range } from 'lodash-es';
import dayjs from 'dayjs';

const getMonth = (val: Date): number => {
  return dayjs(val).month();
};

const getYear = (val: Date): number => {
  return dayjs(val).year();
};

const months = range(0, 12, 1).map(m => {
  if (m < 9) {
    return { value: m.toString(), label: `0${(m + 1).toString()}` };
  }
  return { value: m.toString(), label: (m + 1).toString() };
});

const years = range(getYear(new Date()), getYear(new Date()) + 30, 1).map(y => {
  return { value: y.toString(), label: y.toString() };
});

const renderCustomHeader = (params: ReactDatePickerCustomHeaderProps): JSX.Element => {
  const {
    date: paramDate,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled
  } = params;

  return (
    <div
      style={{
        margin: 10,
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <Button
        className="react-datepicker__header-button"
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
        outline
      >
        <span className="text-primary">{'<'}</span>
      </Button>
      <div className="react-datepicker__select__wrapper">
        <Select
          options={months}
          selectedOption={{
            label: getMonth(paramDate).toString(),
            value: getMonth(paramDate).toString()
          }}
          onChange={(m): void => changeMonth(+m.value)}
          getValue={(m): string => m.value}
          getLabel={(m): string => m.label}
        />
      </div>
      <div className="react-datepicker__select__wrapper">
        <Select
          options={years}
          selectedOption={{
            label: getYear(paramDate).toString(),
            value: getYear(paramDate).toString()
          }}
          onChange={(y): void => changeYear(+y.value)}
          getValue={(y): string => y.value}
          getLabel={(y): string => y.label}
        />
      </div>
      <Button
        className="react-datepicker__header-button"
        size="sm"
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
        outline
      >
        <span className="text-primary">{'>'}</span>
      </Button>
    </div>
  );
};

export default renderCustomHeader;
